export default [
  {
    url: 'https://eng.wealthfront.com/2015/10/29/how-we-avoid-ab-testing-errors-with-shrinkage/',
    title: 'How We Avoid A/B Testing Errors with Shrinkage',
    date: '2015-10-29',
    blog: 'Wealthfront',
  },
  {
    url: 'https://eng.wealthfront.com/2016/12/15/a-specific-trick-and-a-general-habit-for-achieving-fast-computations/',
    title: 'A Specific Trick and a General Habit for Achieving Fast Computations',
    date: '2016-12-15',
    blog: 'Wealthfront',
  },
  {
    url: 'https://thehive.ai/blog/multi-indexing-for-fuzzy-lookup',
    title: 'Multi-Indexing for Fuzzy Lookup',
    date: '2018-01-29',
    blog: 'Hive',
  },
  {
    url: 'https://thehive.ai/blog/evolution-of-a-wiener-process-on-a-sphere',
    title: 'Evolution of a Wiener Process on a Sphere',
    date: '2018-02-22',
    blog: 'Hive',
  },
  {
    url: 'https://thehive.ai/blog/multi-label-classification',
    title: 'Multi-label Classification',
    date: '2018-05-31',
    blog: 'Hive',
  },
  {
    url: 'https://thehive.ai/blog/handling-background-classes-in-machine-learning',
    title: 'Handling "Background" Classes in Machine Learning',
    date: '2018-07-05',
    blog: 'Hive',
  },
  {
    url: 'https://thehive.ai/blog/learning-hash-codes-via-hamming-distance-targets',
    title: 'Learning Hash Codes via Hamming Distance Targets',
    date: '2019-01-18',
    blog: 'Hive',
  },
  {
    url: 'https://thehive.ai/blog/setup-mesos-part1',
    title: 'Spark on Mesos: Setting Up',
    date: '2019-02-12',
    blog: 'Hive',
  },
  {
    url: 'https://thehive.ai/blog/spark-on-mesos-part-2-the-great-disk-leak',
    title: 'Spark on Mesos: The Great Disk Leak',
    date: '2019-03-08',
    blog: 'Hive',
  },
];



// WEBPACK FOOTER //
// src/core/externalPostsByIndex.js